import $ from "jquery"
import LeavesReportPDFSettingsPreview from "./PDFSettingsPreview"
import ParametersFormattingStrategy from "./ParametersFormattingStrategy"
import PDFPreviewController from "../../../pdfPreview/PDFPreviewController";
import LeavesReportStore from '../LeavesReportStore'
import LeaveTypeStore from '../../../store/LeaveTypeStore'
import ATReportParamsStringBuilder from '../../reportParamsStringBuilder/ATReportParamsStringBuilder'

const PDFPreviewLightboxController = function(){};

PDFPreviewLightboxController.prototype = _.create(PDFPreviewController.prototype, {
    
    init: function({lightBoxEl, titleEl, popupId, eventNamespace, productSettingsValidator, reportRightsValidator})
    {
        this.eventNamespace = eventNamespace;
        PDFPreviewController.prototype.init.call(this, lightBoxEl, titleEl, popupId);

        this.productSettingsValidator = productSettingsValidator;
        this.reportRightsValidator = reportRightsValidator;

        return this;
    },

    _initPdfSettingsPreview: function(elementsIdPrefix)
    {
        this.pdfSettingsPreview = new LeavesReportPDFSettingsPreview($(this.lightBoxEl).find(".pdfPreviewContainer"), elementsIdPrefix, this.eventNamespace).init();
    },

    _subscribeForEvents: function()
    {
        var self = this;
        $(document).on(this.eventNamespace + ".pdfGenerator.start", function() { self.onGeneratorStart(); });
        $(this.getStore()).on("generatedPDFChange", function() { self.onGeneratePDFCompleted(); });
    },

    cancelAllExportingProcesses: function ()
    {
        this.pdfViewer.interruptPreview();
    },

    onShow: function()
    {
        this._setTitle(this.createFormattingStrategy(), this._getSelectedParameters());
    },

    createFormattingStrategy: function() {
        return new ParametersFormattingStrategy().init({
            selectorsData: this._getSelectorsData(),
            dateFormat: this.dateFormat,
            productSettingsValidator: this.productSettingsValidator,
            reportRightsValidator: this.reportRightsValidator,
            reportAuthorizationInfo: ATReportsStore.getReportAuthorizationInfo(),
            reportParamsStringBuilderConstructor: ATReportParamsStringBuilder
        })
    },

    onGeneratorStart: function()
    {
        this.disableDownloadPDFButton();
        this.pdfSettingsPreview.beforePreviewUpdate();
        this.pdfViewer.showMoire();
    },

    onDownloadPDFBtnClicked: function()
    {
        if (!this.downloadPDFBtnEnabled)
            return;

        $(document).trigger(this.eventNamespace + ".downloadPDF");
    },

    onGeneratePDFCompleted: function()
    {
        this.pdfViewer.showPDF(this.getStore().getGeneratedPDF());
        this.enableDownloadPDFButton();
    },
    
    getStore: function()
    {
        return LeavesReportStore;
    },

    getGeneralStore: function()
    {
        return ATReportsStore;
    },

    _getSelectedParameters: function()
    {
        var reportParams = this.getStore().getReportParams();
        return {
            balanceQualifier: reportParams.balanceQualifier,
            columnsConfig: reportParams.columnsConfig,
            firstGroupingLevel: reportParams.firstGroupingLevel,
            dateParameters: {
                dateRangeSelection : reportParams.dateRangeSelection
            },
            userSelection: reportParams.userSelection,
            leaveTypeSelection: reportParams.leaveTypeSelection
        }
    },

    _getSelectorsData: function()
    {
        var store = this.getGeneralStore();
        return {
            users: store.getVisibleUsers(),
            userGroupsEnabled: store.getUserGroupsEnabled(),
            timeZoneGroupsEnabled: store.getTimeZoneGroupsEnabled(),
            userGroups: store.getUserGroups(),
            timeZoneGroups: store.getTimeZoneGroups(),
            leaveTypesMap: LeaveTypeStore.getLeaveTypes(),
            manageableUserIds: ATReportsStore.getManageableUserIds()
        }
    }
});

export default PDFPreviewLightboxController


// WEBPACK FOOTER //
// ./web/js/reports/leavesReport/pdfPreview/PDFPreviewLightboxController.js